<div class="modal-dialog-wrap">
  <button type="button" class="modal-dialog-close" [attr.aria-label]="closeLabel" (click)="close()">
    <span class="material-symbols-outlined">close</span>
  </button>

  <div class="modal-dialog-icon" *ngIf="icon">
    <span class="material-symbols-outlined">{{ icon }}</span>
  </div>

  <div class="modal-dialog-icon" *ngIf="image">
    <img [src]="image" [alt]="title || 'Icon'">
  </div>

  <h3 class="modal-dialog-title" *ngIf="title">{{ title }}</h3>
  <p class="modal-dialog-message" *ngIf="message">{{ message }}</p>

  <div class="modal-dialog-actions" *ngIf="buttons.length">
    <button *ngFor="let btn of buttons"
            type="button"
            class="modal-dialog-btn"
            [ngClass]="'modal-dialog-btn--' + btn.style"
            (click)="onButton(btn)">
      {{ btn.label }}
    </button>
  </div>
</div>
